export default __webpack_public_path__ + "static/media/DJ_Snake_-_Magenta_Riddim_(Audio).53bc2ebc.mp3";